import { css } from '@emotion/css';

export const listItemStyle = css`
  :last-of-type .group-list-item {
    border: none !important;
  }
  :hover :not(.disabled).group-list-item {
    box-shadow: 0px -1px 0px 0px var(--bg-primary);
    border-color: transparent !important;
  }
`;
